//@import dependencies
import React from 'react'
import { useTranslation } from 'react-i18next'
//@end

//@import components
import BreadcrumbComponent from 'app_components/commons/breadcrumb';
import StudentLandingModule from 'app_components/modules/admin/landings/studentLanding/index';
import AppContainer from 'app_components/layouts/app'
//@end

// @import hooks
// @end

// @INFO Import types
// @end

// @INFO Import services
// @end

// @INFO Import Styles
import './../studentLandingScreen.scss'

// @ADD Component types
interface IStudentLandingScreenLayoutProps {}

const StudentLandingScreenLayout: React.FC<IStudentLandingScreenLayoutProps> = (props) => {

  const { t } = useTranslation()

  return(
    <AppContainer>
      <div className='student_landing_screen-layout'>
        <BreadcrumbComponent links={['/admin/landings', '#']} texts={[`${t('components.breadcrumb.landings')}`, `${t('components.breadcrumb.student_landing')}`]} />

        <div className="row">
          <div className="col-6">
            <StudentLandingModule />
          </div>
        </div>
      </div>
    </AppContainer>
  )
}

export default StudentLandingScreenLayout
